webpackJsonp([195351340454287],{

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(13);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PostTemplate = function PostTemplate(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    { className: 'container text-center' },
	    _react2.default.createElement(
	      'h1',
	      null,
	      data.strapiPost.title
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'by',
	      ' ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        {
	          to: '/authors/' + (data.strapiPost.author && data.strapiPost.author.id)
	        },
	        data.strapiPost.author && data.strapiPost.username || 'Not specified'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      data.strapiPost.body
	    ),
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: '/' },
	      '\u2190 Go back to the homepage'
	    )
	  );
	};
	
	exports.default = PostTemplate;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-post-js-b5e3944bf27c1885a6e5.js